import { ACTIONS } from '../config/constants';

export function signin() {
  return (dispatch, getState) => {
    dispatch({ type: ACTIONS.TYPES.SIGNIN.SIGNIN_INITIALIZED });
    return ACTIONS.AXIOS(getState().auth ? getState().auth.expiresAt : null)(
      `${ACTIONS.JSON_API_PATH}/account/038c4073-d1bb-400c-8a5d-c7bdf8f5ff92`,
      {
        headers: {
          Authorization: `Bearer ${
            process.env.REACT_APP_MOBILE_TEST
              ? 'MOBILE_TEST_AUTH'
              : getState().auth.accessToken
          }`
        }
      }
    ).then(res =>
      dispatch({
        type: ACTIONS.TYPES.SIGNIN.SIGNIN_SUCCESS,
        user: Object.assign({ id: res.data.data.id }, res.data.data.attributes)
      })
    );
  };
}
export function signout() {
  return dispatch => {
    dispatch({ type: ACTIONS.TYPES.SIGNIN.SIGNOUT_SUCCESS });
  };
}



// WEBPACK FOOTER //
// ./src/actions/session.js